import React, { useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import KnowledgeExplorerHeader from '../components/knowledge/KnowledgeExplorerHeader';
import KnowledgeGraphVisualization from '../components/knowledge/KnowledgeGraphVisualization';
import LegendAndFilters from '../components/knowledge/LegendAndFilters';
import RelatedEvidence from '../components/knowledge/RelatedEvidence';
import SelectedNodeInfo from '../components/knowledge/SelectedNodeInfo';
import { toast } from 'react-toastify';

const KnowledgeExplorer = () => {
  const [selectedNode, setSelectedNode] = useState({
    name: "BRAF V600E Mutation",
    type: "mutation",
    definition: "Substitution at position 600 in the BRAF gene, changing valine (V) to glutamic acid (E)",
    evidence: {
      trials: 14,
      papers: 86,
      guidelines: 3
    },
    treatments: ["Dabrafenib", "Vemurafenib", "Encorafenib"]
  });

  const [activeFilters, setActiveFilters] = useState({
    fdaApproved: true,
    clinicalTrials: true,
    theoretical: false
  });

  // Handle node selection from visualization
  const handleNodeSelect = (node) => {
    // In a real app, this would fetch node data from an API
    setSelectedNode(node);
    toast.info(`Selected node: ${node.name}`);
  };

  // Toggle filter states
  const toggleFilter = (filter) => {
    setActiveFilters({
      ...activeFilters,
      [filter]: !activeFilters[filter]
    });
    toast.info(`Filter ${filter} ${!activeFilters[filter] ? 'enabled' : 'disabled'}`);
  };

  const handleSave = () => {
    // In a real app, this would save the current state of the knowledge graph
    toast.success("Knowledge graph saved successfully");
  };

  return (
    <MainLayout
      activeNavItem="knowledge"
      searchPlaceholder="BRAF mutation melanoma"
      notifications={3}
    >
      <div className="flex h-full">
        <div className="flex-1 p-6 overflow-auto">
          <KnowledgeExplorerHeader
            title="Knowledge Explorer: BRAF Mutation"
            onSave={handleSave}
          />
          
          {/* Pass down the node selection handler */}
          <KnowledgeGraphVisualization onNodeSelect={handleNodeSelect} />
          
          {/* Pass down active filters and toggle handler */}
          <LegendAndFilters 
            activeFilters={activeFilters}
            onFilterToggle={toggleFilter}
          />
          
          <RelatedEvidence selectedNode={selectedNode} />
        </div>
        <div className="w-80">
          <SelectedNodeInfo node={selectedNode} />
        </div>
      </div>
      <div className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300">
        View: Graph | Citations available for all connections | Export available
      </div>
    </MainLayout>
  );
};

export default KnowledgeExplorer;